import montoALetras from '@/helpers/mixMontoALetras';

export default {
  data: () => ({
    meses: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto',
      'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
    ],
    mesesCortos: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago',
      'Sep', 'Oct', 'Nov', 'Dic',
    ],
  }),
  methods: {
    leeArreglo(arr = [], montosALetras = false) {
      const arrFormato = [];
      let arrFormatoOrdenado = [];
      arr.map((e) => {
        if (typeof (e) === 'object' && e !== {} && e !== null) {
          if (Array.isArray(e)) {
            arrFormato.push(this.leeArreglo(e, montosALetras));
          } else {
            arrFormato.push(this.leeObjeto(e, montosALetras));
          }
        } else {
          arrFormato.push(e);
        }
        return true;
      });
      arrFormatoOrdenado = arrFormato.sort(
        (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      );
      return arrFormatoOrdenado;
    },

    leeObjeto(obj = {}, montosALetras = false) {
      const llavesObj = Object.entries(obj);
      const objFormato = {};
      llavesObj.map((e) => {
        if (typeof (e[1]) === 'object' && e[1] !== {} && e[1] !== null) {
          if (Array.isArray(e[1])) {
            objFormato[e[0]] = this.leeArreglo(e[1], montosALetras);
          } else {
            objFormato[e[0]] = this.leeObjeto(e[1], montosALetras);
          }
        } else {
          e[0] = e[0] === 'meta' ? 'objeto' : e[0];
          // eslint-disable-next-line prefer-destructuring
          objFormato[`${e[0]}`] = e[1];
          if (typeof (e[1]) === 'boolean') {
            objFormato[`${e[0]}`] = e[1] ? 'SI' : 'NO';
          }
          if (typeof (e[1]) === 'number') {
            // eslint-disable-next-line prefer-destructuring
            objFormato[`${e[0]}_valor`] = e[1];
            objFormato[`${e[0]}`] = this.formatoMontoComas(e[1]);
            if (montosALetras) {
              objFormato[`${e[0]}_texto`] = montoALetras(e[1]);
            }
          }
          if (e[0].includes('fecha')) {
            objFormato[`${e[0]}_texto`] = this.formatoFechaTexto(e[1]);
            objFormato[`${e[0]}`] = this.formatoFechaSeparador(e[1]);
            objFormato[`${e[0]}_guion`] = this.formatoFechaSeparador(e[1], { separador: '-', letra: true });
          }
        }
        return true;
      });
      return objFormato;
    },

    formatoEstructura(datos = null, agregarNombre = false, montosALetras = false) {
      try {
        if (Object.keys(datos).length === 0) {
          return {};
        }
        const llavesDatos = Object.entries(datos) ? Object.entries(datos) : [];
        const estructuraFormato = {};
        let nombreObjeto = '';
        if (agregarNombre) {
          const objetoTypename = llavesDatos?.filter((e) => e[0] === '__typename');
          if (Array.isArray(objetoTypename) && objetoTypename.length !== 0) {
            nombreObjeto = objetoTypename ? `${objetoTypename[0][1].toLowerCase()}_` : '';
          }
        }
        llavesDatos.map((e) => {
          if (typeof (e[1]) === 'object' && e[1] !== {} && e[1] !== null) {
            if (Array.isArray(e[1])) {
              estructuraFormato[e[0]] = this.leeArreglo(e[1], montosALetras);
            } else {
              estructuraFormato[e[0]] = this.leeObjeto(e[1], montosALetras);
            }
          } else {
            if (e[0] !== '__typename') {
              e[0] = e[0] === 'meta' ? 'objeto' : e[0];
              // eslint-disable-next-line prefer-destructuring
              estructuraFormato[`${nombreObjeto}${e[0]}`] = e[1];
              // eslint-disable-next-line prefer-destructuring
            } else { estructuraFormato[`${e[0]}`] = e[1]; }
            if (typeof (e[1]) === 'boolean') {
              estructuraFormato[`${nombreObjeto}${e[0]}`] = e[1] ? 'SI' : 'NO';
            }
            if (typeof (e[1]) === 'number') {
            // eslint-disable-next-line prefer-destructuring
              estructuraFormato[`${nombreObjeto}${e[0]}_valor`] = e[1];
              estructuraFormato[`${nombreObjeto}${e[0]}`] = this.formatoMontoComas(e[1]);
              if (montosALetras) {
                estructuraFormato[`${nombreObjeto}${e[0]}_texto`] = montoALetras(e[1]);
              }
            }
            if (e[0].includes('fecha')) {
              estructuraFormato[`${nombreObjeto}${e[0]}`] = this.formatoFechaSeparador(e[1]);
              estructuraFormato[`${nombreObjeto}${e[0]}_guion`] = this.formatoFechaSeparador(e[1], { separador: '-', letra: true });
              estructuraFormato[`${nombreObjeto}${e[0]}_texto`] = this.formatoFechaTexto(e[1]);
            }
          }
          return true;
        });

        return estructuraFormato;
      } catch (error) {
        return {};
      }
    },
    formatoMontoComas(importe) {
      return importe
        .toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatoFechaTexto(fecha) {
      if (fecha !== null && fecha !== '') {
        const fechaConFormato = new Date(`${fecha} 00:00:0`)
          .toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
        return fechaConFormato;
      }
      return '';
    },
    formatoFechaDiagonal(fecha) {
      return fecha.toLocaleDateString();
    },
    formatoFechaSeparador(fecha, opciones = {}) {
      const enLetra = opciones?.letra === true ? true : false || false;
      const separador = opciones.separador ? opciones.separador : '/';
      const formatoMes = opciones.formatoMes ? opciones.formatoMes : 'largo';
      if (fecha !== null && fecha !== '') {
        const fechaObjeto = new Date(`${fecha} 00:00:00`);
        if (enLetra) {
          if (formatoMes === 'corto') {
            return `${this.zfill(fechaObjeto.getDate(), 2)}${separador}${this.mesesCortos[fechaObjeto.getMonth()]}${separador}${fechaObjeto.getFullYear()}`;
          }
          return `${this.zfill(fechaObjeto.getDate(), 2)}${separador}${this.meses[fechaObjeto.getMonth()]}${separador}${fechaObjeto.getFullYear()}`;
        }
        return `${this.zfill(fechaObjeto.getDate(), 2)}${separador}${this.zfill(fechaObjeto.getMonth() + 1, 2)}${separador}${fechaObjeto.getFullYear()}`;
      }
      return '';
    },
    zfill(number, width) {
      const numberOutput = Math.abs(number);
      const { length } = number.toString();
      const zero = '0';
      if (width <= length) {
        if (number < 0) {
          return (`-${numberOutput.toString()}`);
        }
        return numberOutput.toString();
      }
      if (number < 0) {
        return (`-${zero.repeat(width - length)}${numberOutput.toString()}`);
      }
      return ((zero.repeat(width - length)) + numberOutput.toString());
    },
    formatoFechaActual() {
      const hoy = new Date().toLocaleDateString('en-US');
      const fechaDelDia = {};
      fechaDelDia.hoy = this.formatoFechaSeparador(hoy);
      fechaDelDia.hoy_guion = this.formatoFechaSeparador(hoy, { separador: '-', letra: true });
      fechaDelDia.hoy_texto = this.formatoFechaTexto(hoy);
      return fechaDelDia;
    },
  },
};
